export const CITIZEN_PORTAL_ROUTES = {
  //DOCUMENTS
  DOCUMENT_CONSULTATION: '/portal-cidadao/documentos/consulta',
  DOCUMENT_CONSULTATION_WITH_QUERY: '/portal-cidadao/documentos/consulta?document_number=xxx&document_code=yyy',
  //SERVICES
  SERVICE: '/portal-cidadao/servicos/[serviceSlug]',
  SERVICES_LIST: '/portal-cidadao/servicos',
  //VACANCIES
  VACANCY: '/portal-cidadao/vagas/[vacancySlug]',
  VACANCIES_LIST: '/portal-cidadao/vagas',
  //GEO
  MAP: '/portal-cidadao/mapa',
  VALIDATE_ADDRESS: '/portal-cidadao/validar-endereco',
}
